<template>
  <div>
    <!-- 产品列表 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>预订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
      <div class="conentRow">
        <div>
          <el-input placeholder="请输入关键字" v-model="data.name" />
          <el-select v-model="data.scenicid" placeholder="全部景区" clearable>
            <el-option
              v-for="item in scenic"
              :key="item.ScenicID"
              :label="item.Name"
              :value="item.ScenicID"
            ></el-option>
          </el-select>
          <!-- <img class="imgPosi" :src="imgXlb" alt /> -->
          <el-select v-model="data.check" placeholder="审核状态" clearable>
            <el-option
              v-for="item in check"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <img class="imgPosi" :src="imgXlb" alt /> -->
          <el-button class="btn1" type="primary" @click="inquire">查询</el-button>
        </div>
        <div>
          <el-button @click="ediiFns()">添加预定单</el-button>
        </div>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width: 100%"
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column prop="numbers" label="单号"></el-table-column>
        <el-table-column prop="itemName" label="团队名称"></el-table-column>
        <el-table-column prop="name" label="联系人"></el-table-column>
        <el-table-column prop="mobile" label="联系方式"></el-table-column>
        <el-table-column prop="totalPrice" label="总金额"></el-table-column>
        <el-table-column prop="num" label="人数"></el-table-column>
        <el-table-column prop="useTime" label="执行日期"></el-table-column>
        <el-table-column prop="check" label="审核状态">
          <template slot-scope="scope">
            <img src="@/images/distributor/dh.png" alt  v-if="scope.row.check==0"/>
            <img src="@/images/distributor/dl.png" alt  v-else/>
            <span style="margin-left:10px"> {{ scope.row.check == 0 ? "未审核" : scope.row.check == 1 ? "审核通过" : scope.row.check == 2 ? "审核驳回" : "" }}</span>
           
          </template>
        </el-table-column>
        <el-table-column  label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="orderInfoFn(scope.row)">订单详情</el-button> -->
            <el-button type="text" @click="ediiFn(scope.row)">修改</el-button>
            <!-- <el-button type="text" style="color: #E74C3C;">删除</el-button> -->
            <el-popconfirm
              confirm-button-text='确认'
              cancel-button-text='取消'
              icon="el-icon-info"
              icon-color="red"
              title="是否删除预订单"
              @confirm="confirms(scope.row.ResOrderID)"
            >
              <div slot="reference">
                删除
              </div>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="total"  :current-page.sync="data.page"  @current-change="currenchange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 订单详情弹框开始 -->
    <advanceListDialog v-if="orderIn" ref="orderFlow"></advanceListDialog>
    <!-- 订单详情弹框结束 -->

    <!-- 产品详情弹框开始 -->
    <editDialog v-if="editvisible" ref="editDialog" @again="getAgain" :scenic="scenic" :orderId="orderId" @Close="getClose"></editDialog>
    <!-- 产品详情弹框结束 -->
  </div>
</template>

<script>
import advanceListDialog from "./dialog/advanceListDialog.vue";
import editDialog from "./dialog/editDialog.vue";
import { getResOrderList ,getDistrbutorScenicList,resOrderDelete} from '@/request/distributor.js'
export default {
  components: {
    advanceListDialog,
    editDialog
  },
  data() {
    return {
      visible: false,
      orderIn:false,//详情
      orderInfovisible: false, // 修改订单
      editvisible: false, // 订单修改
      tableData: [
      ],
      imgXlb: require("@/images/scenic/sj.png"),
      options: [
      ],
      value: "",
      data:{
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:8,
        name:"",
        check:"",
        scenicid:""
      },
      loading:true,
      scenic:[],
      check:[
        {
          value:'0',
          label:'未审核'
        },
        {
          value:'1',
          label:'审核通过'
        },
        {
          value:'2',
          label:'审核驳回'
        }
      ],
      orderId:"",
      total:0
    };
  },
  created(){
    this.getList()
    this.sceniclist()
  },
  methods: {
      // 景区
    sceniclist(){
        let data = {
          token:window.sessionStorage.getItem('Token'),
          page:1,
          page_size:999
        }
        getDistrbutorScenicList(data).then(res=>{
          if(res.data.status=='ok'){
            this.scenic = res.data.result.data
          }
        })
    },
    // 获取列表
    getList(){
      getResOrderList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData= res.data.result.data
          this.loading = false
          this.total = res.data.result.total
        }
      })
    },
    // 添加后静态刷新页面
    getAgain(){
      this.data = {
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:8,
        name:"",
        check:"",
        scenicid:""
      }
      this.getList()
    },
    // 关闭
    getClose(){
      this.editvisible = false
    },
    // 查询
    inquire(){
      this.data.page = 1
      this.loading = true
      this.getList()
    },
    // 添加
    ediiFns(){
      this.editvisible = true;
      this.orderId =  ''
      this.$nextTick(() => {
        this.$refs.editDialog.editOrder();
      });
    },
    // 修改
    ediiFn(row) {
      this.editvisible = true;
      this.orderId = row.ResOrderID
      this.$nextTick(() => {
        this.$refs.editDialog.editOrder(row);
      });
    },
    // 订单详情
    orderInfoFn(row) {
      this.orderIn = true;
      this.$nextTick(() => {
        this.$refs.orderFlow.orderInfo(row);
      });
      console.log( this.editvisible)
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
    // 删除
    confirms(id){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        resorderid:id
      }
      resOrderDelete(data).then(res=>{
        if(res.data.status=='ok'){
          this.getList()
          this.$message.success('删除成功')
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    // 分页
    currenchange(e){
      this.data.page = e
      this.getList()
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.el-card__body {
  padding: 0 20px;
}
.conentBox {
  margin-top: 17px;

  width: 100%;
  .conentRow {
    margin: 20px 0;
    display: flex;
    > div:nth-child(1) {
      width: 70%;
      .el-input {
        width: 240px;
        margin-right: 20px;
      }
      .el-select {
        width: 260px;
        margin-right: 20px;
      }
      .btn1 {
        width: 100px;
        background: #246deb;
        border-radius: 4px;
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        border: none;
        margin-right: 10px;
      }
    }
    > div:nth-child(2) {
      width: 30%;
      display: flex;
      justify-content: flex-end;
      .el-button {
        width: 120px;
        background: #ffffff;
        border: 1px solid #246deb;
        border-radius: 4px;
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #246deb;
      }
    }
  }
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}

/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
::v-deep .el-table_1_column_10:last-child .cell{
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-popover__reference-wrapper{
  color: #66b1ff;
}
::v-deep .el-table_1_column_10:last-child .cell span{
  margin-left: 1rem;
  line-height: 0px;
  cursor: pointer;
}
::v-deep .cell{
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-popover__reference{
  margin-left: 1rem;
  color: #E74C3C !important;
}
</style>